import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { MessageBanner } from "../apps/checkout/MessageBanner";

type IProps = Immutable<templates.MessageBannerTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        // SSR boundary: useAppSelector in MessageBanner requires a DOM wrapper
        // to avoid stale snapshots during SSR.
        <div>
            <MessageBanner tags={props.tags} message={props.message} />
        </div>
    );
};
